import gql from 'graphql-tag';

export default gql`
  mutation ($input: updateHubsWebLinksInput!) {
    updateHubsWebLinks(input: $input) {
      clientMutationId
      viewer {
        id
        heInstitution
        hubsWebLinks {
          premium_links {
            active
            url
            info
            topic
            category
            order
            begin_date
            end_date
            product_id
          }
        }
      }
    }
  }
`;
